var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 406.381,
    height: 426.612,
    viewBox: "0 0 406.381 426.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2286",
    "data-name": "Rect\\xE1ngulo 2286",
    width: 406.381,
    height: 426.612,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2330",
    "data-name": "Rect\\xE1ngulo 2330",
    width: 388.053,
    height: 388.053,
    rx: 144,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2285",
    "data-name": "Rect\\xE1ngulo 2285",
    width: 229.879,
    height: 364.895,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2284",
    "data-name": "Rect\\xE1ngulo 2284",
    width: 50.24,
    height: 96.83,
    transform: "translate(77.339 33.95)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4060",
    "data-name": "Trazado 4060",
    d: "M112.36,103.572v3a17.5,17.5,0,1,1-35,0V103.8l-54.443,8.4A27.029,27.029,0,0,0,.643,144.742l19.391,87.839A14.973,14.973,0,0,0,40.2,243.26l-.516,26.805h120.56l-12.812-68.73,50.145,10.384c18.181,3.764,32.229-10.719,32.3-26.3v-.229A26.2,26.2,0,0,0,222.9,167.6l-40.4-44.885a40.48,40.48,0,0,0-24.384-13l-44.35-6.147Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2587",
    "data-name": "Grupo 2587",
    transform: "translate(-861.273 -245.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2586",
    "data-name": "Grupo 2586",
    transform: "translate(861.273 245.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2581",
    "data-name": "Grupo 2581",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2580",
    "data-name": "Grupo 2580",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4061",
    "data-name": "Trazado 4061",
    d: "M231.326,11.891H167.414A162.07,162.07,0,0,0,5.344,173.961v63.912a162.07,162.07,0,0,0,162.07,162.07h63.912A162.07,162.07,0,0,0,393.4,237.873V173.961a162.07,162.07,0,0,0-162.07-162.07",
    transform: "translate(0.671 1.491)",
    fill: "#ffcdc6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2583",
    "data-name": "Grupo 2583",
    transform: "translate(6.013 13.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2582",
    "data-name": "Grupo 2582",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2287",
    "data-name": "Rect\\xE1ngulo 2287",
    width: 388.052,
    height: 87.141,
    transform: "translate(0.001 326.09)",
    fill: "#ff887a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4062",
    "data-name": "Trazado 4062",
    d: "M166.757,196.849H272.44a2.25,2.25,0,0,0,2.251-2.251V121.449a2.25,2.25,0,0,0-2.251-2.251H166.757a2.25,2.25,0,0,0-2.251,2.251V194.6a2.25,2.25,0,0,0,2.251,2.251",
    transform: "translate(14.63 1.576)",
    fill: "#ffe7e4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_46",
    "data-name": "L\\xEDnea 46",
    x1: 18.621,
    y2: 16.11,
    transform: "translate(288.482 105.945)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4063",
    "data-name": "Trazado 4063",
    d: "M46.18,196.849H151.863a2.25,2.25,0,0,0,2.251-2.251V121.449a2.25,2.25,0,0,0-2.251-2.251H46.18a2.25,2.25,0,0,0-2.251,2.251V194.6a2.25,2.25,0,0,0,2.251,2.251",
    transform: "translate(-0.501 1.576)",
    fill: "#ffe7e4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_47",
    "data-name": "L\\xEDnea 47",
    x1: 18.621,
    y2: 16.11,
    transform: "translate(152.774 105.945)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4064",
    "data-name": "Trazado 4064",
    d: "M.6,196.849H19.624a2.25,2.25,0,0,0,2.251-2.251V121.449a2.25,2.25,0,0,0-2.251-2.251H.6Z",
    transform: "translate(-5.938 1.576)",
    fill: "#ffe7e4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_48",
    "data-name": "L\\xEDnea 48",
    x1: 18.621,
    y2: 16.11,
    transform: "translate(15.098 105.945)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4065",
    "data-name": "Trazado 4065",
    d: "M.6,284.927H19.624a2.25,2.25,0,0,0,2.251-2.251V209.527a2.25,2.25,0,0,0-2.251-2.251H.6Z",
    transform: "translate(-5.938 12.628)",
    fill: "#ffe7e4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_49",
    "data-name": "L\\xEDnea 49",
    x1: 18.621,
    y2: 16.11,
    transform: "translate(15.098 205.075)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4066",
    "data-name": "Trazado 4066",
    d: "M166.757,284.927H272.44a2.25,2.25,0,0,0,2.251-2.251V209.527a2.25,2.25,0,0,0-2.251-2.251H166.757a2.25,2.25,0,0,0-2.251,2.251v73.149a2.25,2.25,0,0,0,2.251,2.251",
    transform: "translate(14.63 12.628)",
    fill: "#ffe7e4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_50",
    "data-name": "L\\xEDnea 50",
    x1: 18.621,
    y2: 16.11,
    transform: "translate(288.482 205.075)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4067",
    "data-name": "Trazado 4067",
    d: "M45.807,284.927H151.49a2.25,2.25,0,0,0,2.251-2.251V209.527a2.25,2.25,0,0,0-2.251-2.251H45.807a2.25,2.25,0,0,0-2.251,2.251v73.149a2.25,2.25,0,0,0,2.251,2.251",
    transform: "translate(-0.548 12.628)",
    fill: "#ffe7e4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_51",
    "data-name": "L\\xEDnea 51",
    x1: 18.621,
    y2: 16.11,
    transform: "translate(152.355 205.075)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4068",
    "data-name": "Trazado 4068",
    d: "M320.128,326.94H1V99.866H314.5a5.627,5.627,0,0,1,5.627,5.627Z",
    transform: "translate(-5.888 -0.85)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2288",
    "data-name": "Rect\\xE1ngulo 2288",
    width: 128.806,
    height: 93.761,
    rx: 2,
    transform: "translate(179.136 104.663)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2289",
    "data-name": "Rect\\xE1ngulo 2289",
    width: 128.806,
    height: 93.761,
    rx: 4,
    transform: "translate(179.136 204.434)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2290",
    "data-name": "Rect\\xE1ngulo 2290",
    width: 128.806,
    height: 93.761,
    rx: 4,
    transform: "translate(43.009 104.663)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2291",
    "data-name": "Rect\\xE1ngulo 2291",
    width: 128.806,
    height: 93.761,
    rx: 4,
    transform: "translate(43.009 204.434)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2292",
    "data-name": "Rect\\xE1ngulo 2292",
    width: 40.575,
    height: 93.761,
    rx: 4,
    transform: "translate(-4.888 104.663)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2293",
    "data-name": "Rect\\xE1ngulo 2293",
    width: 40.575,
    height: 93.761,
    rx: 4,
    transform: "translate(-4.888 204.434)",
    fill: "none",
    stroke: "#ff8b85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2294",
    "data-name": "Rect\\xE1ngulo 2294",
    width: 46.88,
    height: 46.88,
    transform: "translate(48.068 151.544)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2295",
    "data-name": "Rect\\xE1ngulo 2295",
    width: 46.88,
    height: 46.88,
    transform: "translate(48.068 151.544)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2296",
    "data-name": "Rect\\xE1ngulo 2296",
    width: 17.663,
    height: 6.611,
    transform: "translate(69.002 161.8)",
    fill: "#ac504b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4069",
    "data-name": "Trazado 4069",
    d: "M64.93,159.312a6.5,6.5,0,1,1-6.5-6.5,6.5,6.5,0,0,1,6.5,6.5",
    transform: "translate(0.502 5.793)",
    fill: "#ff8b85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2297",
    "data-name": "Rect\\xE1ngulo 2297",
    width: 16.018,
    height: 58.082,
    transform: "translate(96.063 140.785) rotate(-7.079)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2298",
    "data-name": "Rect\\xE1ngulo 2298",
    width: 16.018,
    height: 58.082,
    transform: "translate(96.063 140.785) rotate(-7.079)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2299",
    "data-name": "Rect\\xE1ngulo 2299",
    width: 46.88,
    height: 40.929,
    transform: "translate(69.002 254.679)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2300",
    "data-name": "Rect\\xE1ngulo 2300",
    width: 46.88,
    height: 40.929,
    transform: "translate(69.002 254.679)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2301",
    "data-name": "Rect\\xE1ngulo 2301",
    width: 17.663,
    height: 6.611,
    transform: "translate(81.952 272.031)",
    fill: "#ac504b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4070",
    "data-name": "Trazado 4070",
    d: "M108.3,257.253a6.5,6.5,0,1,1-6.5-6.5,6.5,6.5,0,0,1,6.5,6.5",
    transform: "translate(5.945 18.083)",
    fill: "#ff8b85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2302",
    "data-name": "Rect\\xE1ngulo 2302",
    width: 46.88,
    height: 40.929,
    transform: "translate(181.721 254.873)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2303",
    "data-name": "Rect\\xE1ngulo 2303",
    width: 46.88,
    height: 40.929,
    transform: "translate(181.721 254.873)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2304",
    "data-name": "Rect\\xE1ngulo 2304",
    width: 17.663,
    height: 6.611,
    transform: "translate(194.671 272.224)",
    fill: "#ac504b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4071",
    "data-name": "Trazado 4071",
    d: "M208.457,257.425a6.5,6.5,0,1,1-6.5-6.5,6.5,6.5,0,0,1,6.5,6.5",
    transform: "translate(18.513 18.105)",
    fill: "#ff8b85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2305",
    "data-name": "Rect\\xE1ngulo 2305",
    width: 46.88,
    height: 33.579,
    transform: "translate(181.721 219.904)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2306",
    "data-name": "Rect\\xE1ngulo 2306",
    width: 46.88,
    height: 33.579,
    transform: "translate(181.721 219.904)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2307",
    "data-name": "Rect\\xE1ngulo 2307",
    width: 17.663,
    height: 6.611,
    transform: "translate(194.671 229.905)",
    fill: "#ac504b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4072",
    "data-name": "Trazado 4072",
    d: "M208.457,219.824a6.5,6.5,0,1,1-6.5-6.5,6.5,6.5,0,0,1,6.5,6.5",
    transform: "translate(18.513 13.387)",
    fill: "#ff8b85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2308",
    "data-name": "Rect\\xE1ngulo 2308",
    width: 46.88,
    height: 33.769,
    transform: "translate(238.558 261.868)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2309",
    "data-name": "Rect\\xE1ngulo 2309",
    width: 46.88,
    height: 33.769,
    transform: "translate(238.558 261.868)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2310",
    "data-name": "Rect\\xE1ngulo 2310",
    width: 17.663,
    height: 6.611,
    transform: "translate(251.508 272.059)",
    fill: "#ac504b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4073",
    "data-name": "Trazado 4073",
    d: "M258.957,257.278a6.5,6.5,0,1,1-6.5-6.5,6.5,6.5,0,0,1,6.5,6.5",
    transform: "translate(24.85 18.087)",
    fill: "#ff8b85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2311",
    "data-name": "Rect\\xE1ngulo 2311",
    width: 46.88,
    height: 33.769,
    transform: "translate(184.393 161.8)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2312",
    "data-name": "Rect\\xE1ngulo 2312",
    width: 46.88,
    height: 33.769,
    transform: "translate(184.393 161.8)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2313",
    "data-name": "Rect\\xE1ngulo 2313",
    width: 17.663,
    height: 6.611,
    transform: "translate(197.343 171.992)",
    fill: "#ac504b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4074",
    "data-name": "Trazado 4074",
    d: "M210.83,168.368a6.5,6.5,0,1,1-6.5-6.5,6.5,6.5,0,0,1,6.5,6.5",
    transform: "translate(18.811 6.93)",
    fill: "#ff8b85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2314",
    "data-name": "Rect\\xE1ngulo 2314",
    width: 12.669,
    height: 45.937,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 115.331, 250.052)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2315",
    "data-name": "Rect\\xE1ngulo 2315",
    width: 12.669,
    height: 45.937,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 115.331, 250.052)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2316",
    "data-name": "Rect\\xE1ngulo 2316",
    width: 12.669,
    height: 45.937,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 130.008, 250.052)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2317",
    "data-name": "Rect\\xE1ngulo 2317",
    width: 12.669,
    height: 45.937,
    transform: "matrix(0.992, -0.123, 0.123, 0.992, 130.008, 250.052)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2318",
    "data-name": "Rect\\xE1ngulo 2318",
    width: 12.669,
    height: 45.937,
    transform: "translate(229.441 214.68) rotate(-7.078)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2319",
    "data-name": "Rect\\xE1ngulo 2319",
    width: 12.669,
    height: 45.937,
    transform: "translate(229.441 214.68) rotate(-7.078)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2320",
    "data-name": "Rect\\xE1ngulo 2320",
    width: 12.669,
    height: 45.937,
    transform: "translate(243.765 214.503) rotate(-7.078)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2321",
    "data-name": "Rect\\xE1ngulo 2321",
    width: 12.669,
    height: 45.937,
    transform: "translate(243.765 214.503) rotate(-7.078)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2322",
    "data-name": "Rect\\xE1ngulo 2322",
    width: 12.669,
    height: 45.937,
    transform: "translate(231.273 150.067) rotate(-7.078)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2323",
    "data-name": "Rect\\xE1ngulo 2323",
    width: 12.669,
    height: 45.937,
    transform: "translate(231.273 150.067) rotate(-7.078)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2324",
    "data-name": "Rect\\xE1ngulo 2324",
    width: 12.669,
    height: 45.937,
    transform: "translate(245.596 149.89) rotate(-7.078)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2325",
    "data-name": "Rect\\xE1ngulo 2325",
    width: 12.669,
    height: 45.937,
    transform: "translate(245.596 149.89) rotate(-7.078)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2326",
    "data-name": "Rect\\xE1ngulo 2326",
    width: 12.669,
    height: 45.937,
    transform: "translate(259.901 149.683) rotate(-7.078)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2327",
    "data-name": "Rect\\xE1ngulo 2327",
    width: 12.669,
    height: 45.937,
    transform: "translate(259.901 149.683) rotate(-7.078)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2328",
    "data-name": "Rect\\xE1ngulo 2328",
    width: 12.669,
    height: 45.937,
    transform: "translate(274.224 149.506) rotate(-7.078)",
    fill: "#ffcdc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2329",
    "data-name": "Rect\\xE1ngulo 2329",
    width: 12.669,
    height: 45.937,
    transform: "translate(274.224 149.506) rotate(-7.078)",
    fill: "none",
    stroke: "#e7a6a7",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2585",
    "data-name": "Grupo 2585",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2584",
    "data-name": "Grupo 2584",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4075",
    "data-name": "Trazado 4075",
    d: "M14.056,75.853H79.2A11.775,11.775,0,0,1,90.977,87.629V117.3A11.775,11.775,0,0,1,79.2,129.072H14.056A11.775,11.775,0,0,1,2.28,117.3V87.629A11.775,11.775,0,0,1,14.056,75.853",
    transform: "translate(0.286 9.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2331",
    "data-name": "Rect\\xE1ngulo 2331",
    width: 88.697,
    height: 53.219,
    rx: 10.463,
    transform: "translate(2.566 85.371)",
    fill: "none",
    stroke: "#f18b74",
    strokeWidth: 1.313
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4076",
    "data-name": "Trazado 4076",
    d: "M17.857,108.149,28.251,97.755l9.979,10.394,9.563-10.394,7.483,7.163,9.979-12.34,6.236,7.786",
    transform: "translate(2.241 11.616)",
    fill: "none",
    stroke: "#ff6239",
    strokeWidth: 3.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4077",
    "data-name": "Trazado 4077",
    d: "M376.4,97.209V49.143a24.4,24.4,0,0,0-12.51-21.307L319.55,3.094a24.4,24.4,0,0,0-23.779,0L251.429,27.836a24.4,24.4,0,0,0-12.51,21.307V97.209a24.4,24.4,0,0,0,12.51,21.307l44.342,24.743a24.4,24.4,0,0,0,23.779,0l44.341-24.743A24.4,24.4,0,0,0,376.4,97.209",
    transform: "translate(29.981 -0.001)",
    fill: "#fc654e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_52",
    "data-name": "L\\xEDnea 52",
    x2: 53.219,
    transform: "translate(311.031 98.675)",
    fill: "none",
    stroke: "#fff8ef",
    strokeWidth: 5.254
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_53",
    "data-name": "L\\xEDnea 53",
    x2: 35.479,
    transform: "translate(319.901 111.98)",
    fill: "none",
    stroke: "#ffc6ac",
    strokeWidth: 5.254
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2579",
    "data-name": "Grupo 2579",
    transform: "translate(872 286.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2568",
    "data-name": "Grupo 2568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2567",
    "data-name": "Grupo 2567",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2566",
    "data-name": "Grupo 2566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2565",
    "data-name": "Grupo 2565",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2564",
    "data-name": "Grupo 2564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2563",
    "data-name": "Grupo 2563",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4028",
    "data-name": "Trazado 4028",
    d: "M127.579,38.57V64a43.1,43.1,0,0,1-10.12,27.74,13.739,13.739,0,0,1-4.76,3.65l-.27.12V67.88H79.2V38.57Z",
    fill: "#fcaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4029",
    "data-name": "Trazado 4029",
    d: "M127.579,33.95v4.62H79.2V67.88h-1.83c-.02-.35-.03-.71-.03-1.06V33.95Z",
    fill: "#fcaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4030",
    "data-name": "Trazado 4030",
    d: "M112.429,100.8v12.43a17.545,17.545,0,1,1-35.09,0V67.88h.03a29.748,29.748,0,0,0,3.26,12.6c.09.28.18.56.28.84a30.3,30.3,0,0,0,4.94,8.97,29.221,29.221,0,0,0,22.85,11.02,13.705,13.705,0,0,0,3.73-.51",
    fill: "#fcaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4031",
    "data-name": "Trazado 4031",
    d: "M112.429,95.51v5.29a13.705,13.705,0,0,1-3.73.51,29.221,29.221,0,0,1-22.85-11.02,30.3,30.3,0,0,1-4.94-8.97c-.1-.28-.19-.56-.28-.84a29.581,29.581,0,0,0,3.23,5.02l.2.24a28.976,28.976,0,0,0,22.69,10.95h.1a13.792,13.792,0,0,0,5.58-1.18",
    fill: "#c67777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4032",
    "data-name": "Trazado 4032",
    d: "M112.429,67.88V95.51a13.792,13.792,0,0,1-5.58,1.18h-.1a28.976,28.976,0,0,1-22.69-10.95l-.2-.24a29.581,29.581,0,0,1-3.23-5.02,30.662,30.662,0,0,1-1.43-9.25V67.88Z",
    fill: "#fcaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4033",
    "data-name": "Trazado 4033",
    d: "M80.629,80.48a29.748,29.748,0,0,1-3.26-12.6H79.2v3.35a30.662,30.662,0,0,0,1.43,9.25",
    fill: "#fcaaaa"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4034",
    "data-name": "Trazado 4034",
    d: "M77.339,72.95c-.034-.884-1.305-2.7-2.149-2.064-2.134,1.6-5.411,1.767-8.421-.936a10.052,10.052,0,0,1-3.241-7.5V61.263a6.786,6.786,0,0,1,1.5-4.257c.181-.212.357-.411.527-.592a6.842,6.842,0,0,1,4.833-1.987c.208,0,.413.014.617.031a6.713,6.713,0,0,1,5.88,5.663,9.775,9.775,0,0,0,.8,2.687.653.653,0,0,0,1.206-.066",
    fill: "#fcaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4035",
    "data-name": "Trazado 4035",
    d: "M123.144,60.649a2.523,2.523,0,1,0-2.5,2.864,2.7,2.7,0,0,0,2.5-2.864",
    fill: "#4f1c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4036",
    "data-name": "Trazado 4036",
    d: "M101.728,60.649a2.523,2.523,0,1,0-2.5,2.864,2.7,2.7,0,0,0,2.5-2.864",
    fill: "#4f1c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4037",
    "data-name": "Trazado 4037",
    d: "M107.587,71.8h6.086a.759.759,0,0,0,.726-.981l-2.9-9.467",
    fill: "#f7a6b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4038",
    "data-name": "Trazado 4038",
    d: "M107.587,71.8h6.086a.759.759,0,0,0,.726-.981l-2.9-9.467",
    fill: "none",
    stroke: "#f86980",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4039",
    "data-name": "Trazado 4039",
    d: "M99.228,78.113a10.419,10.419,0,0,0,8.905,3.127",
    fill: "none",
    stroke: "#d44022",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4040",
    "data-name": "Trazado 4040",
    d: "M102.392,49.157c-.156-.882-3.061-1.108-6.49-.505s-6.082,1.807-5.927,2.689Z",
    fill: "#4f0756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4041",
    "data-name": "Trazado 4041",
    d: "M115.15,49.157c.156-.882,3.061-1.108,6.49-.505s6.082,1.807,5.927,2.689Z",
    fill: "#4f0756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4042",
    "data-name": "Trazado 4042",
    d: "M105.142,77.025l7.073.731c-.317,3.068-3.771,5.263-7.651,4.862s-6.812-3.255-6.5-6.324Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4043",
    "data-name": "Trazado 4043",
    d: "M73.729,66.793c-.407-3.125-2.818-5.915-5.089-5.37",
    fill: "none",
    stroke: "#5d4022",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4044",
    "data-name": "Trazado 4044",
    d: "M131.018,37.233s-3.361,10.659-17.4,10.241C99.549,47.056,97.1,30.529,83.442,30.529V28.667h47.343Z",
    fill: "#e59798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4045",
    "data-name": "Trazado 4045",
    d: "M78.876,64.117a.7.7,0,0,1-1.329.3,17.408,17.408,0,0,1-1.408-6.406c-.082-1.759-4.13-5.493-9.939-2.015-4.889-2.655-4.356-20.157-3.51-26.381,1.368-10.066,10.207-9.6,10.207-9.6S71.2,8.386,89.291,4.785c3.207-.638,20.368-2.468,20.06,14.2,1.131-11.008-6.73-13.271-13.682-17.591,11.918-5.864,40.737,8.024,35.9,19.031,4.4,2.263,4.32,8.245,3.75,13.537C133.806,48.03,127.375,64,127.375,64v-24.5s-1.991,2.67-11.016,2.67c-9.813,0-20.264-8.837-29.044-7.643C77.07,35.926,78.761,44.1,78.876,64.117",
    fill: "#1e1147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4046",
    "data-name": "Trazado 4046",
    d: "M75.217,70.875a5.768,5.768,0,0,1-2.292,1.038,65.055,65.055,0,0,0,4.414,7.238V72.735c-.188-.928-1.338-2.45-2.122-1.86",
    fill: "#1e1147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4047",
    "data-name": "Trazado 4047",
    d: "M155.707,270.064H40.481L26.487,364.9l146.17-2.435Z",
    fill: "#2d2875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4048",
    "data-name": "Trazado 4048",
    d: "M105.8,363.574l4.659-50.718,17.728-7.931",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2570",
    "data-name": "Grupo 2570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2569",
    "data-name": "Grupo 2569",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4049",
    "data-name": "Trazado 4049",
    d: "M222.9,167.6l-40.4-44.885a40.49,40.49,0,0,0-24.384-13l-44.35-6.147-35.221.054h-.029l-55.6,8.578A27.029,27.029,0,0,0,.643,144.743l19.392,87.838A14.972,14.972,0,0,0,40.2,243.26h0l-.516,26.8H160.247l-12.811-68.729,50.144,10.383c25.32,5.243,42.621-24.9,25.322-44.12",
    fill: "#3c82f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4050",
    "data-name": "Trazado 4050",
    d: "M39.841,262.109,40.2,243.26l107.954-41.925Z",
    fill: "#2b5bba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4051",
    "data-name": "Trazado 4051",
    d: "M146.253,163.228l1.44-11.291-62.211,8.336Z",
    fill: "#2c5aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4052",
    "data-name": "Trazado 4052",
    d: "M40.571,244.2,147.59,202.164,83.58,190.448",
    fill: "none",
    stroke: "#001482",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4053",
    "data-name": "Trazado 4053",
    d: "M95.058,131.574h-1.4a24.3,24.3,0,0,1-24.3-24.3v-25.7h50v25.7A24.3,24.3,0,0,1,95.058,131.574Z",
    fill: "none",
    stroke: "#001482",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4054",
    "data-name": "Trazado 4054",
    d: "M55.08,197.2l28.5-6.75-.75-30-32.875,13Z",
    fill: "#ffc2cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4055",
    "data-name": "Trazado 4055",
    d: "M185.33,167.948l-37.637-3.5a28.365,28.365,0,0,1,21.857-17.091l1.03-.159Z",
    fill: "#ffc2cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4056",
    "data-name": "Trazado 4056",
    d: "M161.663,159.919c2.23-3.948,6.934-5.769,12.124-8.208",
    fill: "none",
    stroke: "#250037",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4057",
    "data-name": "Trazado 4057",
    d: "M166.348,164.6c2.094-3.513,6.263-5.712,10.8-8.167",
    fill: "none",
    stroke: "#250037",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4058",
    "data-name": "Trazado 4058",
    d: "M174.6,166.3c1.216-2.156,3.443-3.336,6.077-4.9",
    fill: "none",
    stroke: "#250037",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_44",
    "data-name": "L\\xEDnea 44",
    x1: 14.75,
    y1: 20.75,
    transform: "translate(170.58 147.198)",
    fill: "none",
    stroke: "#250037",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4059",
    "data-name": "Trazado 4059",
    d: "M82.83,160.449l63.423,2.78,2.3-18.064",
    fill: "none",
    stroke: "#001482",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_45",
    "data-name": "L\\xEDnea 45",
    x2: 9.745,
    y2: 45.159,
    transform: "translate(45.335 152.039)",
    fill: "none",
    stroke: "#001482",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeCustomers);
export default __webpack_public_path__ + "static/media/WelcomeCustomers.90f798b2790869e83dada183fa5f5f67.svg";
export { ForwardRef as ReactComponent };